import { BlogPostDto } from '../types';

/** Prefer the time-limited S3 GET URL. The stored public CDN host is not always resolvable. */
export function resolveBlogFeaturedImageSrc(
  post: Pick<BlogPostDto, 'featuredImageDisplayUrl' | 'featuredImageUrl'> | null | undefined
): string | null {
  const display = typeof post?.featuredImageDisplayUrl === 'string' ? post.featuredImageDisplayUrl.trim() : '';
  if (display) return display;
  const stored = typeof post?.featuredImageUrl === 'string' ? post.featuredImageUrl.trim() : '';
  return stored || null;
}

export function cssUrl(value: string): string {
  const escaped = String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return `url("${escaped}")`;
}
